<template>
 <div id="organizational-view" class="minHeight">
   <section class="section-1">
      <i-title :titleOne="'组织架构'" :titleTwo="'全面详细了解组织信息'"></i-title>
      <img src="../../assets/images/organizational.png" class="structure">
   </section>
   <section class="section-2">
      <i-title :titleOne="'从业人员'" :titleTwo="'截至2018年8月31日，从业人员数量34人'"></i-title>
      <div class="chart-img">
        <div id="adb-chart" :options="adbOptions"></div>
        <div id='edb-chart' :options="edbOptions"></div>
      </div>
   </section>
   <autograph></autograph>
 </div>
</template>

<script>
import autograph from '@/components/autograph'
import informationTitle from '@/components/informationTitle'
if (typeof window !== 'undefined') {
  var ECharts = require('echarts')
  require('echarts/lib/chart/pie')
  require('echarts/lib/component/polar')
  require('echarts-gl')
}
export default {
  data () {
    let ageDatas = [
      {value: 3, name: '36岁以上：3人'},
      {value: 4, name: '31~35岁：4人'},
      {value: 11, name: '26~30岁：11人'},
      {value: 16, name: '25岁及以下：16人'}
    ]
    let educationData = [
      {value: 2, name: '研究生：2人'},
      {value: 20, name: '本科：20人'},
      {value: 12, name: '大专及以下：12人'}
    ]
    return {
      adbOptions: {
        title: {
          text: '年龄结构分布',
          x: 35,
          align: 'right'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}'
        },
        legend: {
          orient: 'vertical',
          x: 240,
          y: 70,
          padding: [20, 2],
          itemGap: 20,
          align: 'left',
          itemWidth: 10,
          itemHeight: 10
        },
        color: [
          '#ffc460',
          '#fe8687',
          '#74b4f1',
          '#8995f7'
        ],
        series: [
          {
            name: '访问来源',
            type: 'pie',
            center: [105, 150],
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                },
                formatter: '{d}%'
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: ageDatas
          }
        ]
      },
      edbOptions: {
        title: {
          text: '学历结构分布',
          x: 80,
          align: 'right'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}'
        },
        color: ['#BD8DBF', '#FCAF5D', '#82CA9C'],
        legend: {
          orient: 'vertical',
          x: 265,
          y: 70,
          padding: [20, 0],
          itemGap: 20,
          align: 'left',
          backgroundColor: 'rgba(0,0,0,0)',
          itemWidth: 10,
          itemHeight: 10
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            center: [140, 150],
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                },
                formatter: '{d}%'
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: educationData
          }
        ]
      }
    }
  },
  mounted () {
    this.verifyLogin().then((res) => {}).catch(() => {})
    let adbChart = ECharts.init(document.getElementById('adb-chart'))
    let edbChart = ECharts.init(document.getElementById('edb-chart'))
    adbChart.setOption(this.adbOptions)
    edbChart.setOption(this.edbOptions)
  },
  components: {
    'autograph': autograph,
    'i-title': informationTitle
  }
}
</script>

<style lang="less">
#organizational-view{
  width:980px;
  float: left;
  overflow: hidden;
  background: #fff;
  margin-left: 20px;
  margin-bottom: 20px;
  position: relative;
  .section-1{
    .structure{
      width: 780px;
      margin: 0 auto;
    }
  }
  .section-2{
    margin-bottom: 50px;
    .chart-img{
      width: 780px;
      margin:0 auto;
      >div{
        display: inline-block;
        width: 380px;
        height: 260px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/information/organizational.vue